import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { hiveExperteTerminStatus } from '../../../../dtos';
import { calendarColors } from '../../../../theme/colorPalette';
import { content } from '../../../../utils';
import { formatBuchungsnummern } from '../../../../utils/themaProdukte';
import { HoverCard } from '../../HoverCard';
import { getSlashedLinesColor } from '../createCalendarColors.ts';
import { isExperteEvent, isSeminarraumEvent } from '../helperClasses';
import {
  type AbstractCalendarEvent,
  type InternalCalendarEvent,
  isStandortEvent,
} from '../helperClasses/CalendarEvent';
import { VeranstaltungEventButton } from './VeranstaltungEventButton';
import { VivaEventTooltip } from './VivaEventTooltip';

type VivaEventProps = {
  readonly calendarEvent: InternalCalendarEvent;
};

const printRaumgroesse = (event: AbstractCalendarEvent): string | null => {
  const raumgroesse = event.blockungData.raumgroesse;

  return raumgroesse ? `${raumgroesse}${content.unitsWs.qm}` : null;
};

const getSubInfoByEvent = (event: AbstractCalendarEvent): string | null => {
  if (isSeminarraumEvent(event)) {
    return printRaumgroesse(event);
  } else if (isStandortEvent(event)) {
    return printRaumgroesse(event);
  } else if (isExperteEvent(event)) {
    return event.blockungData.locationKuerzel ?? event.blockungData.onlineTool;
  } else {
    return null;
  }
};

const getEventColor = (event: AbstractCalendarEvent): string => {
  if (
    isExperteEvent(event) &&
    (event.blockungData.status === hiveExperteTerminStatus.GEPLANT ||
      (!event.blockungData.status && !event.blockungData.veranstaltung?.veranstaltungSapId))
  ) {
    return getSlashedLinesColor(alpha(calendarColors.internalBlockung, 0.5), calendarColors.internalBlockung);
  } else {
    return calendarColors.internalBlockung;
  }
};

export const VivaEvent = ({ calendarEvent }: VivaEventProps) => (
  <HoverCard title={<VivaEventTooltip event={calendarEvent} />} placement="bottom" arrow>
    <Box>
      <VeranstaltungEventButton
        eventColor={getEventColor(calendarEvent)}
        akaVeranstaltungId={calendarEvent.blockungData.veranstaltung.akaVeranstaltungId}
      >
        <Stack>
          <Typography variant="paragraphSm" color="textPrimaryOnBrand">
            {formatBuchungsnummern(calendarEvent.blockungData.veranstaltung.thema)}
          </Typography>
          <Typography variant="paragraphSm" color="textPrimaryOnBrand" fontSize=".6rem" textAlign="center">
            {getSubInfoByEvent(calendarEvent) ?? (
              <div>
                <br />
              </div>
            )}
          </Typography>
        </Stack>
      </VeranstaltungEventButton>
    </Box>
  </HoverCard>
);
